import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SeoServiceService {
  constructor(@Inject(DOCUMENT) private doc: Document) {}

  createLinkForCanonicalURL() {
    let link: HTMLLinkElement = this.doc.createElement("link");
    link.setAttribute("rel", "canonical");
    this.doc.head.appendChild(link);
    link.setAttribute("href", this.doc.URL);
  }
}
